import isURL from "validator/es/lib/isURL";

import { isNumber } from "../../utils/isNumber";

export function threadIdIsCorrect(value: string | number) {
  return new Promise<number>((resolve) => {
    const trimmedValue = typeof value === 'string' ? value.trim() : value.toString()

    if (trimmedValue) {
      if (isURL(trimmedValue)) {
        const splitTopicLink = trimmedValue.split('/')
        const id = splitTopicLink.at(-1)

        if (id && isNumber(id)) {
          resolve(Number.parseInt(id))
        }
      } else if (isNumber(trimmedValue)) {
        resolve(Number.parseInt(trimmedValue))
      }
    }

    throw new Error('notification_warning_editor_custom_topic_value')
  })
}
